// extracted by mini-css-extract-plugin
export var details = "_e4-0";
export var inspectorPopover = "_e4-1";